import {Component, Input} from '@angular/core';
import {routesNames} from "@app/app-routing.module";
import {ListActionModalService} from "@app/presentation/services/list-service/list-action-modal.service";
import {take} from "rxjs/operators";
import {Product} from "@app/core/product/domain/dtos/product";
import {ToastService} from "@app/presentation/services/toast/toast.service";
import {TranslateService} from "@ngx-translate/core";
import {LocalizedRouter} from "@app/presentation/services/localized-router";

@Component({
  selector: 'ep-fav-button',
  templateUrl: './fav-button.component.html',
  styleUrls: ['./fav-button.component.scss']
})
export class FavButtonComponent {

  @Input() product?: Product | null;

  @Input() isFavorite?: boolean = false;

  @Input() returnUrl: string | null = null;

  routesNames = routesNames;

  constructor(
    private listService: ListActionModalService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private localizedRouter: LocalizedRouter,
  ) { }

  addProductToList() {
    if(this.product) {
      this.listService.openAddToList(this.product, this.returnUrl).pipe(take(1)).subscribe({
          next: list => {
            if (list == null) {
                return;
            }
            const isFavoriteList = list?.isFavoriteList;
            const actionMessage = isFavoriteList ? 'action_message.catalog.successfully_added_to_favorites' : 'action_message.catalog.successfully_added_to_list';
            this.toastService.show(this.translateService.instant(actionMessage),() => {
              this.localizedRouter.navigate(['/', routesNames.listDetail, list.code])
            })
            if(isFavoriteList) {
              this.isFavorite = true
            }
          }
      });
    }

  }
}
